<template>
    <div>
        <div v-if="loaderMessage != ''" class="pt-3">
            <span v-if="isLoader">
                {{ loaderMessage }}
                <span
                    class="spinner-border ml-auto"
                    role="status"
                    aria-hidden="true"
                ></span>
            </span>

            <span v-if="isError" class="text-danger">
                {{ loaderMessage }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotificationLoader',
    computed: {
        loaderMessage() {
            return this.$store.state.loader.message
        },
        isLoader() {
            if (this.$store.state.loader.type == 'loader') {
                return true
            } else {
                return false
            }
        },
        isError() {
            if (this.$store.state.loader.type == 'error') {
                return true
            } else {
                return false
            }
        },
    },
}
</script>

<style scoped>
.error {
    color: red;
}

.loader {
    color: gray;
}
</style>
